import classnames from 'classnames'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'

import { matchApprove, matchDisapprove } from '../../../../../pages/sports/soccer/MatchPageActions'
import Message from '../../../../modals/Message'
import MiniHeader from '../MiniHeader'

import './Actions.css'

const MATCH_STATES = {
  BOTH_LOSE: 'BL',
  LOCAL_W: 'LW',
  VISITOR_W: 'VW',
}

class Actions extends Component {
  state = {
    action: null,
    matchState: null,
  }

  onCloseMessage = () => {
    this.setState({
      action: null,
    })
  }

  onLockClick = () => {
    const {
      match: { local, visitor },
    } = this.props

    let localScore = 0
    let localDefinitionScore = 0
    let visitorScore = 0
    let visitorDefinitionScore = 0
    this.props.match.events.forEach((event) => {
      const isLocal = event.team.id === local.id
      const isGoal = event.type.indexOf('GOAL') === 0
      const isDefinition = event.type === 'PENAL_DEFINITION'
      if (isGoal) {
        if (isLocal) {
          localScore += 1
        } else {
          visitorScore += 1
        }

        if (event.type === 'GOAL_AUTO') {
          if (isLocal) {
            visitorScore += 1
            localScore -= 1
          } else {
            localScore += 1
            visitorScore -= 1
          }
        }
      } else if (isDefinition) {
        if (isLocal) {
          localDefinitionScore += 1
        } else {
          visitorDefinitionScore += 1
        }
      }
    })

    const message = (
      <div>
        Estás {this.state.matchState ? ' bloqueando ' : ' aprobando '}
        <b>{this.props.match.events.length}</b> eventos.
        <br />
        <br />
        {!this.state.matchState && (
          <div>
            - Esta acción <b>modificará la credibilidad</b> de los usuarios involucrados.
            <br />- Este marcador <b> puede ser diferente</b> al que vez en la parte superior.
          </div>
        )}
        <div>
          <MiniHeader
            bothLose={this.state.matchState === MATCH_STATES.BOTH_LOSE}
            local={local}
            localDefinitionScore={localDefinitionScore}
            localScore={localScore}
            localWalkover={this.state.matchState === MATCH_STATES.LOCAL_W}
            size="big"
            status="approved"
            visitor={visitor}
            visitorDefinitionScore={visitorDefinitionScore}
            visitorScore={visitorScore}
            visitorWalkover={this.state.matchState === MATCH_STATES.VISITOR_W}
          />
        </div>
        <div>
          <label className="MatchHeaderActions__bothLose" htmlFor="localWCheckbox">
            <input
              id="localWCheckbox"
              checked={this.state.matchState === MATCH_STATES.LOCAL_W}
              onChange={(e) =>
                this.setState({ matchState: e.target.checked ? MATCH_STATES.LOCAL_W : null }, this.onLockClick)
              }
              type="checkbox"
              value={1}
            />
            Pierde {local.name} por <b>W</b>
          </label>
          <label className="MatchHeaderActions__bothLose" htmlFor="visitorWCheckbox">
            <input
              id="visitorWCheckbox"
              checked={this.state.matchState === MATCH_STATES.VISITOR_W}
              onChange={(e) =>
                this.setState({ matchState: e.target.checked ? MATCH_STATES.VISITOR_W : null }, this.onLockClick)
              }
              type="checkbox"
              value={1}
            />
            Pierde {visitor.name} por <b>W</b>
          </label>
          <label className="MatchHeaderActions__bothLose" htmlFor="bothLoseCheckbox">
            <input
              id="bothLoseCheckbox"
              checked={this.state.matchState === MATCH_STATES.BOTH_LOSE}
              onChange={(e) =>
                this.setState({ matchState: e.target.checked ? MATCH_STATES.BOTH_LOSE : null }, this.onLockClick)
              }
              type="checkbox"
              value={1}
            />
            Pierden ambos equipos
          </label>
          {this.state.matchState === MATCH_STATES.BOTH_LOSE && (
            <textarea
              id="bothLoseInput"
              className="MatchHeaderActions__bothLose__reason"
              maxLength={200}
              name="both_lose_reason"
              onChange={(e) => this.setState({ bothLoseReason: e.target.value }, this.onLockClick)}
              placeholder="Motivo:"
              rows={2}
            />
          )}
        </div>
      </div>
    )

    const options = [
      {
        content: 'Cancelar',
        onClick: this.onCloseMessage,
      },
      {
        content: this.state.matchState === MATCH_STATES.BOTH_LOSE ? 'Pierden Ambos' : 'Cerrar Partido',
        negative: !!this.state.matchState,
        onClick: () => {
          this.props.matchApprove(
            this.props.match.id,
            this.state.matchState === MATCH_STATES.LOCAL_W,
            this.state.matchState === MATCH_STATES.VISITOR_W,
            this.state.matchState === MATCH_STATES.BOTH_LOSE,
            this.state.matchState === MATCH_STATES.BOTH_LOSE ? this.state.bothLoseReason : null,
          )
          this.setState({
            bothLoseReason: '',
            matchState: null,
          })
          this.onCloseMessage()
        },
        primary: true,
      },
    ]
    this.setState({
      action: <Message message={message} onClose={this.onCloseMessage} options={options} />,
    })
  }

  onUnlockClick = () => {
    const message = (
      <div>
        <br />
        Estás permitiendo la modificación pública de este partido.
        <br />
        <br />- Esta acción <b>modificará la credibilidad</b> de los usuarios involucrados.
        <br />
        <br />- El proceso puede tardar unos minutos pero no necesitas esperar en esta pantalla.
      </div>
    )

    const options = [
      {
        content: 'Cancelar',
        onClick: this.onCloseMessage,
      },
      {
        content: 'Abrir Partido',
        onClick: () => {
          this.props.matchDisapprove(this.props.match.id)
          this.onCloseMessage()
        },
        primary: true,
      },
    ]
    this.setState({
      action: <Message message={message} onClose={this.onCloseMessage} options={options} />,
    })
  }

  render() {
    const { className, compact, environment, match } = this.props
    const { action } = this.state

    const smallDevice = environment.stage.small
    const tinyDevice = environment.stage.tiny
    const isAdmin = match.access && match.access.level === 1
    const start = parseInt(match.started_at || match.matched_at || 0, 10)
    const end = parseInt(match.ended_at || moment.utc().valueOf() / 1000, 10)
    const canLock = match.approved_at || !!match.ended_at || end - start > 60 * 60

    const styleAdd = {
      height: 'auto',
      margin: '-5px 0 -55px -3px',
      maxWidth: '135px',
    }

    if (smallDevice) {
      styleAdd.maxWidth = '95px'
      styleAdd.margin = '0 0 -50px -8px'
    }
    if (tinyDevice) {
      styleAdd.maxWidth = '80px'
      styleAdd.margin = '0 0 -40px -8px'
    }

    if (!action && !isAdmin) {
      return null
    }

    return (
      <div className={classnames('MatchHeaderActions', className, { compact })}>
        {action}
        {isAdmin && canLock && (
          <div className="MatchHeaderActions__holder">
            <Icon
              circular
              className="MatchHeaderActions__table__secure"
              color="black"
              inverted
              name={match.approved_at ? 'lock' : 'unlock alternate'}
              onClick={match.approved_at ? this.onUnlockClick : this.onLockClick}
              role="button"
              size="small"
              tabIndex={-1}
              title={match.approved_at ? 'Abrir partido' : 'Cerrar partido'}
            />
            <div className="MatchHeaderActions__label">{match.approved_at ? 'Abrir' : 'Cerrar'}</div>
          </div>
        )}
      </div>
    )
  }
}

Actions.propTypes = {
  compact: PropTypes.bool,
  environment: PropTypes.object,
  match: PropTypes.object.isRequired,
  matchApprove: PropTypes.func,
  matchDisapprove: PropTypes.func,

  className: PropTypes.string,
}

Actions.defaultProps = {
  className: '',
  compact: false,
  environment: {},
  matchApprove: Function.prototype,
  matchDisapprove: Function.prototype,
}

export default connect(
  ({
    auth: { usr: user },
    environment,
    match: {
      data: { 0: match },
    },
  }) => ({
    environment,
    match,
    user,
  }),
  {
    matchApprove,
    matchDisapprove,
  },
)(Actions)
